import React from 'react';
import { Modal, Table, Tag, Typography } from 'antd';

interface Row {
  key: string;
  combo: React.ReactNode;
  action: string;
}

const SHORTCUTS: Row[] = [
  { key: 'arrows', combo: <Tag>← ↑ → ↓</Tag>, action: 'Sposta focus tra le celle' },
  { key: 'tab', combo: <Tag>Tab / Shift+Tab</Tag>, action: 'Prossima / precedente cella editabile' },
  { key: 'enter', combo: <Tag>Enter</Tag>, action: 'Conferma edit e scendi di una riga' },
  { key: 'esc', combo: <Tag>Esc</Tag>, action: 'Annulla edit corrente' },
  { key: 'f2', combo: <Tag>F2</Tag>, action: 'Entra in edit sulla cella focused' },
  { key: 'plus', combo: <Tag>+ / −</Tag>, action: 'Incrementa / decrementa numero focused di 1' },
  { key: 'shift_plus', combo: <Tag>Shift + / Shift −</Tag>, action: 'Incrementa / decrementa di 5' },
  { key: 'ins', combo: <Tag>Ins</Tag>, action: 'Inserisci nuova riga' },
  { key: 'del', combo: <Tag>Del</Tag>, action: 'Elimina riga focused (chiede conferma)' },
  { key: 'save', combo: <Tag color="blue">Ctrl + S</Tag>, action: 'Salva tutte le modifiche in sospeso' },
  { key: 'discard', combo: <Tag color="orange">Ctrl + D</Tag>, action: 'Scarta tutte le modifiche in sospeso' },
  { key: 'g', combo: <Tag color="purple">G</Tag>, action: 'Risultato veloce sulla riga focused (macro)' },
  { key: 'l', combo: <Tag>L</Tag>, action: 'Toggle lock Punti (auto ↔ manuale)' },
  { key: 'ctrl_l', combo: <Tag>Ctrl + L</Tag>, action: 'Apri MediaSelector per cambiare logo' },
  { key: 't', combo: <Tag>T</Tag>, action: 'Imposta riga focused come Tenant' },
  { key: 'help', combo: <Tag>?</Tag>, action: 'Apri questa guida' },
];

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ShortcutsHelpModal({ open, onClose }: Props): React.ReactElement {
  return (
    <Modal title="Scorciatoie da tastiera" open={open} onCancel={onClose} footer={null} width={560}>
      <Typography.Paragraph type="secondary" style={{ marginTop: 0 }}>
        Attive quando la tabella ha il focus. + e − funzionano sulle celle numeriche senza dover entrare in modifica.
      </Typography.Paragraph>
      <Table<Row>
        size="small"
        dataSource={SHORTCUTS}
        pagination={false}
        showHeader={false}
        columns={[
          { dataIndex: 'combo', key: 'combo', width: 160 },
          { dataIndex: 'action', key: 'action' },
        ]}
      />
    </Modal>
  );
}
